"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderToastContainer_unstable", {
    enumerable: true,
    get: function() {
        return renderToastContainer_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _toastContainerContext = require("../../contexts/toastContainerContext");
const _reactmotioncomponentspreview = require("@fluentui/react-motion-components-preview");
const renderToastContainer_unstable = (state, contextValues)=>{
    const { onMotionFinish, visible, updateId } = state;
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_toastContainerContext.ToastContainerContextProvider, {
        value: contextValues.toast,
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_reactmotioncomponentspreview.CollapseDelayed, {
            appear: true,
            onMotionFinish: onMotionFinish,
            visible: visible,
            unmountOnExit: true,
            children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(state.root, {
                children: [
                    state.root.children,
                    /*#__PURE__*/ (0, _jsxruntime.jsx)(state.timer, {}, updateId)
                ]
            })
        })
    });
};
